import Vue from 'vue';
import FilesProxy from '@/proxies/Files';
import FilesTransform from '@/transforms/Files';
import ProjectsProxy from '@/proxies/Projects';
import ProjectsTransform from '@/transforms/Projects';
import TeamsProxy from '@/proxies/Teams';
import TeamsTransform from '@/transforms/Teams';
import PlayersProxy from '@/proxies/Players';
import PlayersTransform from '@/transforms/Players';


const SEARCH_RESULTS = 'SEARCH_RESULTS';

export default {
  namespaced: true,
  state: {
    results: [],
  },
  getters: {
    results: state => state.results,
  },
  actions: {
    load({ commit, dispatch }, payload) {
      let proxy;
      let transform;
      let key;
      switch (payload.type) {
        case Vue.$app.route.FILES:
          proxy = new FilesProxy();
          transform = FilesTransform;
          key = 'files';
          break;
        case Vue.$app.route.PROJECTS:
          proxy = new ProjectsProxy();
          transform = ProjectsTransform;
          key = 'jobs';
          break;
        case Vue.$app.route.TEAMS:
          proxy = new TeamsProxy();
          transform = TeamsTransform;
          key = 'teams';
          break;
        case Vue.$app.route.PLAYERS:
          proxy = new PlayersProxy();
          transform = PlayersTransform;
          key = 'players';
          break;
        case Vue.$app.route.VENUES:
          proxy = new VenuesProxy();
          transform = VenuesTransform;
          key = 'venues';
          break;
        case Vue.$app.route.TRACK_MANAGER:
          proxy = new PlayersProxy();
          transform = PlayersTransform;
          key = 'players';
          break;
        default:
      }

      if (proxy) {
        proxy
          .search(encodeURIComponent(payload.keyword))
          .then((response) => {
            commit(SEARCH_RESULTS, transform.fetchCollection(response[key]));
          })
          .catch(() => {
          // TODO: error message
            dispatch('notification/error', 'errormessage.request_failed_report', { root: true });
          });
      } else {
        commit(SEARCH_RESULTS, []);
      }
    },
  },
  mutations: {
    [SEARCH_RESULTS](state, payload) {
      state.results = payload;
    },
  },
};
